import type { TestSource } from "@/types/ab-tests";
import { SOURCE_LABELS } from "./constants";

export function getTestSourceLabel(source: TestSource): string {
  return SOURCE_LABELS[source] ?? source;
}

export function scopeLabel(f: string): string {
  return f === "title" ? "Title" : `Bullet ${f.split("-")[1]}`;
}

export const toDateInput = (iso?: string) => (iso ? iso.slice(0, 10) : "");
